var render = function render(){
  var _vm$meeting;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.tabValue
    }
  }, [_c('v-layout', {
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-card-subtitle', [_c('v-chip', [_vm._v(_vm._s((_vm$meeting = _vm.meeting) === null || _vm$meeting === void 0 ? void 0 : _vm$meeting.title))])], 1), _c('v-card-title', [_vm._v("매칭가능 기간이 아닙니다.")]), _c('v-card-subtitle', {
    staticClass: "text-center"
  }, [_vm._v(" 매칭가능 일정을 확인해주세요. ")]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._t("tab-complete-actions")], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }